module.exports = __webpack_public_path__ + "static/img/guide-match-btn.c38810c.png";